import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-assortment',
  templateUrl: './assortment.component.html',
  styleUrls: ['./assortment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class AssortmentComponent {
}
